import { useState } from "react";
import { useLookupLogsQuery } from "../../stores/OkOkStore";
import type { LogMessages } from "../../types/LogMessages";
import Pager from "../Common/Pager";
import { NavLink } from "react-router";
import { useTrads } from "../../contexts/trads/useTrads";

function LogsList(){
    const [params,setParams]=useState<Record<string, string>>({page:"0"});
    const { data, error, isLoading } = useLookupLogsQuery(params);
    const {translate}=useTrads();

    const setPage=function(page:number){
        setParams({...params,page: page.toString()})
    }

        return (
 
            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <>
                <table className="table">
                <thead>
                    <tr>
                        <th>Level</th>
                        <th>Message</th>
                        <th>date_creation</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {data.data.map((log:LogMessages) => (

                        <tr key={log.id}>
                            <td>{log.level}</td>
                            <td>{log.message}</td>
                            <td>
                                {log.date_creation}
                            </td>                            
                            <td>
                                
                                <NavLink to={`/logs/${log.id.toString()}`}>
                                    <span className="visually-hidden">{translate('btn_voir')}</span>
                                    <i className="bi bi-eye-fill"></i>
                                </NavLink>
                            </td>
                            
                        </tr>

                    ))}

                </tbody>
                </table>
                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                
                </>
            ):null
        );
}
export default LogsList;